// Ausführlicher SEO-Content pro Leistung: Meta-Daten, Langtexte, FAQ, interne Verlinkung.
// Keyed by service slug.

export const serviceRegions =
  "Augsburg und Umgebung – darunter Königsbrunn, Gersthofen, Stadtbergen, Neusäß, Friedberg, Bobingen, Diedorf, Schwabmünchen und Landsberg am Lech";

export const serviceSeo = {
  "unterhaltsreinigung-augsburg": {
    metaTitle:
      "Unterhaltsreinigung Augsburg | Büro- & Gewerbereinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Unterhaltsreinigung in Augsburg für Büros, Praxen & Gewerbe. Tägliche, wöchentliche oder individuelle Intervalle – zertifiziert, versichert & mit fester Ansprechperson. Jetzt kostenloses Angebot anfordern!",
    sections: [
      {
        heading: "Unterhaltsreinigung in Augsburg – dauerhaft saubere Objekte",
        paragraphs: [
          "Die Unterhaltsreinigung ist das Fundament eines gepflegten und repräsentativen Objekts. Als Gebäudereinigung aus Augsburg übernehmen wir die regelmäßige Reinigung Ihrer Büros, Praxen, Kanzleien, Ladenlokale und Gewerbeobjekte – nach einem exakt auf Ihren Betrieb abgestimmten Reinigungsplan. So bleibt Ihr Objekt Tag für Tag sauber, hygienisch und einladend, ohne dass Sie sich um Details kümmern müssen.",
          "Unser geschultes Reinigungspersonal arbeitet zuverlässig, diskret und termintreu. Ob täglich, mehrmals pro Woche oder in individuell festgelegten Intervallen – wir passen Uhrzeiten, Umfang und Frequenz an Ihre Abläufe an. Dabei setzen wir auf moderne, umweltfreundliche Reinigungsmittel und dokumentieren jede Leistung transparent nachvollziehbar.",
        ],
      },
      {
        heading: "Was gehört zur Unterhaltsreinigung?",
        paragraphs: [
          "Die Unterhaltsreinigung umfasst alle wiederkehrenden Reinigungsarbeiten, die für ein sauberes und hygienisches Arbeitsumfeld sorgen. Dazu zählen die Boden­reinigung (Saugen, Wischen, Pflegen), die Reinigung und Desinfektion der Sanitäranlagen, die Pflege von Küchen und Teeküchen sowie das Leeren der Abfallbehälter. Ebenso gehören das Abstauben von Oberflächen, Tischen und Ablagen sowie die Reinigung von Türen, Griffen und Lichtschaltern dazu.",
          "Auf Wunsch erweitern wir die Unterhaltsreinigung um zusätzliche Leistungen wie die Innenreinigung von Glasflächen, die Auffüllung von Verbrauchsmaterialien (Seife, Papierhandtücher, Toilettenpapier) oder eine regelmäßige Grundreinigung stark beanspruchter Bereiche. So erhalten Sie ein durchdachtes Gesamtkonzept aus einer Hand.",
        ],
      },
      {
        heading: "Hygiene nach VDI 6022 – wichtig für Praxen und Büros",
        paragraphs: [
          "Gerade in Arztpraxen, Kanzleien und Büros mit hohem Publikumsverkehr spielt Hygiene eine zentrale Rolle. Wir reinigen nach anerkannten Hygienestandards und legen besonderen Wert auf Kontaktflächen wie Türklinken, Handläufe und sanitäre Bereiche. So reduzieren Sie das Infektionsrisiko und schaffen ein gesundes Umfeld für Mitarbeitende und Besucher.",
          "Ein sauberes Objekt ist außerdem ein starkes Aushängeschild: Kunden und Geschäftspartner nehmen Sauberkeit unbewusst als Zeichen von Professionalität und Wertschätzung wahr. Mit einer regelmäßigen Unterhaltsreinigung investieren Sie damit direkt in Ihr Image und den Werterhalt Ihrer Immobilie.",
        ],
      },
      {
        heading: "Feste Ansprechperson & flexible Zeiten",
        paragraphs: [
          "Bei MAG Facility Services erhalten Sie eine feste Ansprechperson, die Ihr Objekt und Ihre Anforderungen genau kennt. Kurze Wege, verlässliche Kommunikation und eine gleichbleibende Qualität stehen bei uns im Mittelpunkt. Auf Wunsch reinigen wir außerhalb Ihrer Geschäftszeiten – früh morgens, abends oder am Wochenende – damit Ihr Betrieb ungestört weiterläuft.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Unterhaltsreinigung in Augsburg?",
        a: "Die Kosten richten sich nach Objektgröße, Reinigungsintervall und gewünschtem Leistungsumfang. Nach einer kostenlosen Besichtigung erstellen wir Ihnen ein transparentes Festpreis- oder Stundenangebot – ganz ohne versteckte Kosten.",
      },
      {
        q: "Wie oft sollte ein Büro gereinigt werden?",
        a: "Das hängt von der Personenzahl und Nutzung ab. Kleine Büros kommen oft mit 1–2 Reinigungen pro Woche aus, während stark frequentierte Büros oder Praxen meist eine tägliche Reinigung benötigen. Wir beraten Sie gerne zum optimalen Intervall.",
      },
      {
        q: "Reinigen Sie auch außerhalb der Geschäftszeiten?",
        a: "Ja. Auf Wunsch reinigen wir früh morgens, abends oder am Wochenende, damit Ihr Betriebsablauf nicht gestört wird. Die Zeiten stimmen wir individuell mit Ihnen ab.",
      },
      {
        q: "In welchen Orten sind Sie tätig?",
        a: "Wir sind in Augsburg und der gesamten Umgebung im Einsatz, u. a. in Königsbrunn, Gersthofen, Stadtbergen, Neusäß, Friedberg, Bobingen und Schwabmünchen.",
      },
      {
        q: "Stellen Sie die Reinigungsmittel selbst?",
        a: "Ja, wir bringen alle benötigten Reinigungsmittel und Geräte mit. Auf Wunsch verwenden wir ausschließlich umweltfreundliche und materialschonende Produkte.",
      },
    ],
    related: ["treppenhausreinigung-augsburg", "glasreinigung-augsburg", "grundreinigung-augsburg"],
  },

  "treppenhausreinigung-augsburg": {
    metaTitle:
      "Treppenhausreinigung Augsburg | Wohn- & Bürogebäude | MAG Facility Services",
    metaDescription:
      "Zuverlässige Treppenhausreinigung in Augsburg für Wohnanlagen & Bürogebäude. Stufen, Geländer, Fenster & Eingangsbereiche in verlässlichen Intervallen. Jetzt kostenloses Angebot anfordern!",
    sections: [
      {
        heading: "Treppenhausreinigung in Augsburg – die Visitenkarte Ihres Objekts",
        paragraphs: [
          "Das Treppenhaus ist der erste Bereich, den Mieter, Besucher und Geschäftspartner betreten – und damit die Visitenkarte jedes Gebäudes. Als Gebäudereinigung aus Augsburg sorgen wir mit einer regelmäßigen Treppenhausreinigung für einen dauerhaft gepflegten und einladenden Eindruck in Wohnanlagen, Mehrfamilienhäusern und Bürogebäuden.",
          "Wir übernehmen die turnusmäßige Reinigung sämtlicher Etagen, inklusive Eingangsbereich, Briefkastenanlage, Aufzug und Kellerfluren. Dabei arbeiten wir nach einem festen, verlässlichen Plan, sodass Sauberkeit und Ordnung jederzeit gewährleistet sind.",
        ],
      },
      {
        heading: "Was umfasst die Treppenhausreinigung?",
        paragraphs: [
          "Zur Treppenhausreinigung gehören das Wischen und Pflegen der Stufen und Podeste, die Reinigung von Handläufen und Geländern, das Entfernen von Spinnweben sowie die Reinigung von Fenstern und Fensterbänken im Treppenhaus. Ebenso reinigen wir Eingangstüren, Klingelanlagen und Briefkästen sowie den Eingangsbereich vor dem Gebäude.",
          "Auf Wunsch erweitern wir die Leistung um die Pflege von Aufzugskabinen, Kellerabgängen, Waschküchen und Gemeinschaftsräumen. So erhalten Sie ein rundum gepflegtes Objekt – abgestimmt auf die Bedürfnisse von Hausverwaltungen und Eigentümergemeinschaften.",
        ],
      },
      {
        heading: "Verlässliche Intervalle für Hausverwaltungen & Eigentümer",
        paragraphs: [
          "Wir wissen, wie wichtig Verlässlichkeit für Hausverwaltungen und Eigentümergemeinschaften ist. Deshalb reinigen wir Ihr Treppenhaus in fest vereinbarten Intervallen – ob wöchentlich, 14-tägig oder monatlich. Jede Reinigung wird dokumentiert, sodass Sie und Ihre Mieter jederzeit einen transparenten Überblick behalten.",
          "Gerade in Mehrparteienhäusern beugt eine professionelle Treppenhausreinigung Konflikten unter Mietern vor, die sonst häufig durch wechselnde Reinigungspläne entstehen. Sie sparen Verwaltungsaufwand und sorgen gleichzeitig für zufriedene Mieter und ein gepflegtes Objekt.",
        ],
      },
      {
        heading: "Werterhalt und Sicherheit",
        paragraphs: [
          "Eine saubere und ordentliche Reinigung schützt nicht nur das Erscheinungsbild, sondern auch die Bausubstanz: Schmutz, Streusalz und Feuchtigkeit werden regelmäßig entfernt, bevor sie Böden und Materialien angreifen. Gleichzeitig erhöhen saubere, rutschfreie Treppen die Sicherheit für alle Bewohner und Besucher.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Treppenhausreinigung in Augsburg?",
        a: "Der Preis richtet sich nach Anzahl der Etagen, Reinigungsintervall und Leistungsumfang. Nach einer kurzen Besichtigung erhalten Sie von uns ein transparentes Festpreisangebot – meist auf monatlicher Basis abrechenbar.",
      },
      {
        q: "In welchem Intervall sollte ein Treppenhaus gereinigt werden?",
        a: "In den meisten Wohnanlagen ist eine wöchentliche oder 14-tägige Reinigung sinnvoll. Bei hohem Aufkommen oder größeren Objekten empfehlen wir kürzere Intervalle. Wir beraten Sie gern individuell.",
      },
      {
        q: "Reinigen Sie auch außerhalb der üblichen Zeiten?",
        a: "Ja, wir stimmen die Reinigungszeiten flexibel mit Ihnen bzw. Ihrer Hausverwaltung ab, um Mieter möglichst wenig zu stören.",
      },
      {
        q: "In welchen Orten bieten Sie Treppenhausreinigung an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Friedberg.",
      },
      {
        q: "Übernehmen Sie auch die Reinigung mehrerer Objekte gleichzeitig?",
        a: "Ja, für Hausverwaltungen betreuen wir gerne mehrere Objekte im Verbund – mit einheitlicher Qualität und einer zentralen Ansprechperson.",
      },
    ],
    related: ["unterhaltsreinigung-augsburg", "glasreinigung-augsburg", "hausmeisterservice-augsburg"],
  },

  "glasreinigung-augsburg": {
    metaTitle:
      "Glasreinigung Augsburg | Fenster & Glasfassaden streifenfrei | MAG Facility Services",
    metaDescription:
      "Professionelle Glas- und Fensterreinigung in Augsburg – streifenfrei, auch in der Höhe. Fenster, Rahmen & Glasfassaden für Büros, Gewerbe & Privat. Jetzt kostenloses Angebot anfordern!",
    sections: [
      {
        heading: "Glasreinigung in Augsburg – für klare Durchsicht",
        paragraphs: [
          "Saubere Fenster und Glasflächen lassen mehr Licht in Ihre Räume, sorgen für ein angenehmes Raumklima und hinterlassen einen professionellen Eindruck. Als Gebäudereinigung aus Augsburg bieten wir Ihnen eine streifenfreie Glasreinigung für Büros, Ladenlokale, Praxen, Gewerbeobjekte und Privathaushalte – gründlich, zuverlässig und mit modernem Equipment.",
          "Ob einzelne Fensterfronten, große Schaufenster oder komplette Glasfassaden: Wir reinigen jede Glasfläche fachgerecht und rückstandsfrei. Rahmen, Falze und Fensterbänke reinigen wir dabei selbstverständlich mit, damit das Ergebnis rundum überzeugt.",
        ],
      },
      {
        heading: "Auch schwer zugängliche Glasflächen und Höhenarbeiten",
        paragraphs: [
          "Für höher gelegene Fenster und Glasfassaden setzen wir moderne Teleskop- und Reinwassertechnik ein. Mit entkalktem, entmineralisiertem Wasser reinigen wir Glasflächen streifenfrei – ganz ohne chemische Zusätze und bis in große Höhen. Wo nötig, führen wir gesicherte Höhenarbeiten fachgerecht und unter Beachtung aller Sicherheitsvorgaben durch.",
          "Diese Technik ist besonders schonend und effizient: Sie ermöglicht die Reinigung schwer erreichbarer Bereiche ohne aufwändige Gerüste und sorgt gleichzeitig für ein langanhaltend sauberes Ergebnis, da keine Rückstände von Reinigungsmitteln zurückbleiben.",
        ],
      },
      {
        heading: "Regelmäßige Glasreinigung oder Einzelauftrag",
        paragraphs: [
          "Wir übernehmen sowohl einmalige Glasreinigungen – etwa nach einer Baumaßnahme oder vor einem wichtigen Termin – als auch regelmäßige Reinigungen im Rahmen eines Wartungsvertrags. Gerade bei Schaufenstern, Eingangstüren und Glastrennwänden empfiehlt sich eine regelmäßige Reinigung, um einen dauerhaft gepflegten Eindruck zu bewahren.",
          "Für Gewerbeobjekte lässt sich die Glasreinigung ideal mit unserer Unterhaltsreinigung kombinieren, sodass Sie alle Reinigungsleistungen aus einer Hand erhalten – abgestimmt auf Ihren individuellen Bedarf.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Glasreinigung in Augsburg?",
        a: "Die Kosten hängen von der Anzahl und Größe der Glasflächen, der Erreichbarkeit und der Verschmutzung ab. Nach einer kurzen Besichtigung oder anhand von Fotos erstellen wir Ihnen ein transparentes Angebot.",
      },
      {
        q: "Wie oft sollten Fenster gereinigt werden?",
        a: "Bei Gewerbeobjekten und Schaufenstern empfehlen wir eine monatliche bis vierteljährliche Reinigung. Bei stark beanspruchten Flächen kann ein kürzeres Intervall sinnvoll sein.",
      },
      {
        q: "Reinigen Sie auch Fenster in großer Höhe?",
        a: "Ja, mit Teleskop- und Reinwassertechnik reinigen wir auch hoch gelegene Fenster und Glasfassaden. Bei Bedarf führen wir gesicherte Höhenarbeiten durch.",
      },
      {
        q: "In welchen Orten bieten Sie Glasreinigung an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Stadtbergen, Neusäß und Friedberg.",
      },
      {
        q: "Reinigen Sie auch Wintergärten, Glasdächer und Trennwände?",
        a: "Ja, neben Fenstern und Fassaden reinigen wir auch Wintergärten, Glasdächer, Glastrennwände und Vitrinen – innen wie außen.",
      },
      {
        q: "Bieten Sie Glasreinigung auch als regelmäßigen Service an?",
        a: "Ja, gerne im Rahmen eines Wartungsvertrags in festen Intervallen. Für Gewerbeobjekte lässt sich die Glasreinigung ideal mit der Unterhaltsreinigung kombinieren.",
      },
    ],
    related: ["fassadenreinigung-augsburg", "unterhaltsreinigung-augsburg", "baureinigung-augsburg"],
  },

  "grundreinigung-augsburg": {
    metaTitle:
      "Grundreinigung Augsburg | Intensive Tiefenreinigung | MAG Facility Services",
    metaDescription:
      "Intensive Grundreinigung in Augsburg für Böden, Teppiche & stark beanspruchte Bereiche. Entfernt hartnäckigen Schmutz & alte Pflegefilme – inkl. Beschichtung. Jetzt Angebot anfordern!",
    sections: [
      {
        heading: "Grundreinigung in Augsburg – Tiefenreinigung für Ihr Objekt",
        paragraphs: [
          "Die Grundreinigung geht deutlich tiefer als die regelmäßige Unterhaltsreinigung. Als Gebäudereinigung aus Augsburg entfernen wir hartnäckige Verschmutzungen, alte Pflegefilme und Ablagerungen, die sich über Monate oder Jahre angesammelt haben. Das Ergebnis: Böden, Oberflächen und stark beanspruchte Bereiche erstrahlen wie neu.",
          "Eine Grundreinigung empfiehlt sich in regelmäßigen Abständen – etwa ein- bis zweimal jährlich – oder anlassbezogen, zum Beispiel bei einem Mieterwechsel, nach Renovierungsarbeiten oder vor einer wichtigen Veranstaltung. Sie ist die ideale Basis für eine anschließend wieder gepflegte Unterhaltsreinigung.",
        ],
      },
      {
        heading: "Was umfasst eine professionelle Grundreinigung?",
        paragraphs: [
          "Bei der Grundreinigung reinigen wir Böden intensiv mit geeigneten Maschinen und Verfahren – abgestimmt auf den jeweiligen Bodenbelag wie PVC, Linoleum, Fliesen, Naturstein oder Parkett. Wir entfernen alte Wachs- und Pflegeschichten, reinigen Fugen und bringen die Oberflächen anschließend auf Wunsch mit einer schützenden Beschichtung oder Versiegelung wieder auf Hochglanz.",
          "Darüber hinaus umfasst die Grundreinigung die intensive Reinigung von Sanitäranlagen inklusive Entkalkung, die Reinigung von Türen, Heizkörpern, Fensterbänken und Lampen sowie die Behandlung von Teppichböden und Polstern. So wird jeder Bereich Ihres Objekts von Grund auf erneuert.",
        ],
      },
      {
        heading: "Schutz und Werterhalt Ihrer Böden",
        paragraphs: [
          "Eine fachgerechte Grundreinigung mit anschließender Beschichtung schützt Ihre Böden langfristig: Die schützende Schicht erleichtert die tägliche Reinigung, verlängert die Lebensdauer des Bodenbelags und bewahrt ein gepflegtes Erscheinungsbild. Gerade bei hochwertigen Böden ist dies eine lohnende Investition in den Werterhalt Ihrer Immobilie.",
          "Wir beraten Sie individuell, welches Verfahren und welche Pflegeprodukte für Ihren Bodenbelag am besten geeignet sind – materialschonend und mit langanhaltendem Ergebnis.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Grundreinigung in Augsburg?",
        a: "Die Kosten richten sich nach Fläche, Bodenbelag und Verschmutzungsgrad. Nach einer Besichtigung erstellen wir Ihnen ein transparentes Angebot – auf Wunsch inklusive Beschichtung.",
      },
      {
        q: "Wie oft ist eine Grundreinigung sinnvoll?",
        a: "In der Regel empfehlen wir eine Grundreinigung ein- bis zweimal jährlich sowie anlassbezogen bei Mieterwechsel oder nach Baumaßnahmen.",
      },
      {
        q: "Reinigen Sie auch außerhalb der Geschäftszeiten?",
        a: "Ja, gerade Grundreinigungen führen wir gerne abends, am Wochenende oder in Betriebsferien durch, damit Ihr Ablauf nicht gestört wird.",
      },
      {
        q: "In welchen Orten bieten Sie Grundreinigung an?",
        a: "Wir sind in Augsburg und Umgebung im Einsatz, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Bobingen.",
      },
      {
        q: "Was ist der Unterschied zwischen Grund- und Unterhaltsreinigung?",
        a: "Die Unterhaltsreinigung hält den Sauberkeitszustand regelmäßig aufrecht, während die Grundreinigung als intensive Tiefenreinigung alte Pflegefilme und hartnäckige Ablagerungen komplett entfernt.",
      },
      {
        q: "Für welche Bodenbeläge eignet sich die Grundreinigung?",
        a: "Für nahezu alle: PVC, Linoleum, Fliesen, Naturstein und Parkett. Wir wählen für jeden Belag das passende, materialschonende Verfahren.",
      },
    ],
    related: ["unterhaltsreinigung-augsburg", "teppich-polsterreinigung-augsburg", "baureinigung-augsburg"],
  },

  "baureinigung-augsburg": {
    metaTitle:
      "Baureinigung Augsburg | Bauendreinigung & Bauzwischenreinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Baureinigung in Augsburg: Bauzwischen-, Bauend- & Erstreinigung nach Neubau, Umbau oder Sanierung. Bezugsfertiges Objekt, gründlich & zuverlässig. Jetzt Angebot anfordern!",
    sections: [
      {
        heading: "Baureinigung in Augsburg – bezugsfertig übergeben",
        paragraphs: [
          "Nach Bau-, Umbau- oder Renovierungsarbeiten bleibt meist eine Menge Schmutz zurück: Baustaub, Kleberreste, Farbspritzer, Mörtel und Etiketten. Als Gebäudereinigung aus Augsburg übernehmen wir die komplette Baureinigung und übergeben Ihnen ein bezugsfertiges, sauberes Objekt – ob Neubau, Sanierung oder Umbau von Wohn- und Gewerbeflächen.",
          "Wir kennen die besonderen Anforderungen einer Baustelle und arbeiten mit geeigneter Technik und geschultem Personal. Dabei stimmen wir uns eng mit Bauleitung und Gewerken ab, damit die Reinigung reibungslos in den Bauablauf integriert wird.",
        ],
      },
      {
        heading: "Bauzwischenreinigung, Bauendreinigung & Erstreinigung",
        paragraphs: [
          "Die Bauzwischenreinigung erfolgt während der Bauphase und schafft saubere Bedingungen für die nachfolgenden Gewerke – etwa vor dem Verlegen von Böden oder dem Innenausbau. Die Bauendreinigung bzw. Bauabschlussreinigung entfernt anschließend sämtliche Bauverschmutzungen, sodass das Objekt übergeben werden kann.",
          "Die Erstreinigung (auch Feinreinigung genannt) sorgt schließlich für den letzten Feinschliff vor dem Einzug: Wir reinigen alle Oberflächen, Fenster, Türen, Sanitäranlagen und Böden gründlich, entfernen letzte Staubschichten und Etiketten und machen das Objekt bezugsfertig.",
        ],
      },
      {
        heading: "Warum eine professionelle Baureinigung?",
        paragraphs: [
          "Baustaub ist besonders fein und setzt sich in jeder Ritze fest – ohne fachgerechte Reinigung verteilt er sich immer wieder neu. Mit professionellen Industriesaugern, geeigneten Reinigungsmitteln und dem richtigen Vorgehen entfernen wir Baustaub und Rückstände nachhaltig und schonen dabei die neuen Oberflächen und Materialien.",
          "So sparen Sie Zeit und Aufwand und stellen sicher, dass Ihr frisch gebautes oder saniertes Objekt von Anfang an in bestem Zustand ist. Gerne kombinieren wir die Baureinigung mit einer anschließenden regelmäßigen Unterhaltsreinigung.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Baureinigung in Augsburg?",
        a: "Die Kosten hängen von Fläche, Verschmutzungsgrad und Umfang (Bauzwischen-, Bauend- oder Erstreinigung) ab. Nach einer Besichtigung erhalten Sie ein transparentes Angebot.",
      },
      {
        q: "Wann sollte die Baureinigung stattfinden?",
        a: "Die Bauzwischenreinigung erfolgt während der Bauphase, die Bauend- und Feinreinigung kurz vor der Übergabe bzw. dem Einzug. Wir stimmen die Termine flexibel mit Ihrer Bauleitung ab.",
      },
      {
        q: "Arbeiten Sie auch am Wochenende oder kurzfristig?",
        a: "Ja, gerade bei engen Bauzeitenplänen sind wir flexibel und übernehmen Reinigungen auch am Wochenende oder kurzfristig.",
      },
      {
        q: "In welchen Orten bieten Sie Baureinigung an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Friedberg und Bobingen.",
      },
    ],
    related: ["grundreinigung-augsburg", "glasreinigung-augsburg", "unterhaltsreinigung-augsburg"],
  },

  "muellentsorgung-augsburg": {
    metaTitle:
      "Müllentsorgung Augsburg | Abfalltrennung & Containermanagement | MAG Facility Services",
    metaDescription:
      "Zuverlässige Müllentsorgung in Augsburg: fachgerechte Abfalltrennung, Containerbewirtschaftung & regelmäßige Abholung für Gewerbe & Wohnanlagen. Umweltbewusst & zuverlässig. Jetzt anfragen!",
    sections: [
      {
        heading: "Müllentsorgung in Augsburg – sauber und fachgerecht",
        paragraphs: [
          "Eine geordnete Abfallentsorgung ist für jedes Objekt wichtig – für die Sauberkeit, die Hygiene und die Umwelt. Als Gebäudereinigung aus Augsburg übernehmen wir die zuverlässige Müllentsorgung, die korrekte Abfalltrennung und die Bewirtschaftung Ihrer Container- und Müllstellplätze für Gewerbeobjekte, Wohnanlagen und Verwaltungen.",
          "Wir sorgen dafür, dass Ihre Abfälle regelmäßig und fachgerecht entsorgt werden, und halten die Müllstellplätze sauber und geruchsarm. So vermeiden Sie überfüllte Behälter, Verschmutzungen und Beschwerden von Mietern oder Nachbarn.",
        ],
      },
      {
        heading: "Abfalltrennung & Containermanagement",
        paragraphs: [
          "Die korrekte Trennung von Restmüll, Papier, Verpackungen, Bioabfall und Glas ist gesetzlich vorgeschrieben und schont die Umwelt. Wir unterstützen Sie bei der ordnungsgemäßen Trennung, stellen die Behälter zur Abholung bereit und führen sie anschließend wieder an ihren Platz zurück. Auf Wunsch übernehmen wir auch die Reinigung der Müllbehälter und -stellplätze.",
          "Für größere Objekte organisieren wir das komplette Containermanagement – von der bedarfsgerechten Dimensionierung über die Bewirtschaftung bis zur Koordination mit den Entsorgungsunternehmen. So behalten Sie stets den Überblick und sparen Verwaltungsaufwand.",
        ],
      },
      {
        heading: "Umweltbewusst und zuverlässig",
        paragraphs: [
          "Nachhaltigkeit liegt uns am Herzen: Durch eine sorgfältige Abfalltrennung erhöhen wir die Recyclingquote und reduzieren die Menge des Restmülls. Gleichzeitig sorgen wir mit verlässlichen Abholrhythmen dafür, dass es zu keinen Engpässen oder Überfüllungen kommt.",
          "Gerne kombinieren wir die Müllentsorgung mit unserem Hausmeisterservice oder der Unterhaltsreinigung, sodass die Betreuung Ihres Objekts vollständig aus einer Hand erfolgt.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet die Müllentsorgung in Augsburg?",
        a: "Die Kosten richten sich nach Objektgröße, Abfallmenge und gewünschtem Leistungsumfang. Wir erstellen Ihnen nach einer kurzen Bedarfsaufnahme ein transparentes Angebot.",
      },
      {
        q: "Übernehmen Sie auch die Reinigung der Müllstellplätze?",
        a: "Ja, auf Wunsch reinigen wir Müllbehälter und -stellplätze regelmäßig, damit sie sauber und geruchsarm bleiben.",
      },
      {
        q: "In welchem Intervall erfolgt die Abholung?",
        a: "Das legen wir individuell nach Ihrem Bedarf fest – von mehrmals wöchentlich bis monatlich. So vermeiden wir Überfüllungen zuverlässig.",
      },
      {
        q: "In welchen Orten sind Sie tätig?",
        a: "Wir sind in Augsburg und Umgebung im Einsatz, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Friedberg.",
      },
    ],
    related: ["hausmeisterservice-augsburg", "unterhaltsreinigung-augsburg", "winterdienst-augsburg"],
  },

  "sonderreinigungen-augsburg": {
    metaTitle:
      "Sonderreinigung Augsburg | Küchen, Werkstätten & Notfälle | MAG Facility Services",
    metaDescription:
      "Individuelle Sonderreinigungen in Augsburg: Großküchen, Werkstätten, Events & Notfallreinigung nach Wasser- oder Sturmschäden. Flexibel & kurzfristig im Einsatz. Jetzt Angebot anfordern!",
    sections: [
      {
        heading: "Sonderreinigungen in Augsburg – flexibel für jede Aufgabe",
        paragraphs: [
          "Nicht jede Reinigungsaufgabe passt in ein Standardschema. Genau für diese Fälle sind wir da: Als Gebäudereinigung aus Augsburg übernehmen wir Sonderreinigungen aller Art – flexibel, individuell und auf Wunsch auch kurzfristig. Ob Großküche, Werkstatt, Veranstaltungsfläche oder akuter Notfall: Wir stellen uns auf Ihre besondere Anforderung ein.",
          "Unser erfahrenes Team verfügt über das nötige Know-how und die passende Ausstattung, um auch anspruchsvolle und ungewöhnliche Reinigungsaufgaben professionell zu bewältigen – gründlich, zuverlässig und mit einem Blick fürs Detail.",
        ],
      },
      {
        heading: "Unsere Sonderreinigungen im Überblick",
        paragraphs: [
          "Zu unseren Sonderreinigungen zählen die Küchentiefenreinigung in Gastronomie und Kantinen (inklusive Fettabscheider, Dunstabzug und Geräten), die Reinigung von Werkstätten, Produktions- und Lagerhallen sowie die Reinigung von Veranstaltungsflächen vor und nach Events, Messen oder Feiern.",
          "Darüber hinaus führen wir Notfallreinigungen nach Wasser-, Sturm- oder Brandschäden durch, reinigen nach Havarien und übernehmen Spezialaufgaben wie die Reinigung von Tiefgaragen, Außenanlagen oder besonderen Oberflächen. Sprechen Sie uns einfach an – wir finden für nahezu jede Aufgabe eine Lösung.",
        ],
      },
      {
        heading: "Schnell erreichbar bei Notfällen",
        paragraphs: [
          "Bei akuten Notfällen zählt jede Minute. Deshalb sind wir für unsere Kunden auch kurzfristig erreichbar und rücken schnell aus, um Schäden zu begrenzen und die betroffenen Bereiche wieder nutzbar zu machen. Mit unserem Notfallservice haben Sie einen verlässlichen Partner an Ihrer Seite, wenn es darauf ankommt.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Sonderreinigung in Augsburg?",
        a: "Da Sonderreinigungen sehr individuell sind, richtet sich der Preis nach Art, Umfang und Dringlichkeit der Aufgabe. Wir erstellen Ihnen nach einer kurzen Aufnahme ein transparentes Angebot.",
      },
      {
        q: "Sind Sie auch kurzfristig im Notfall erreichbar?",
        a: "Ja, bei Notfällen wie Wasser- oder Sturmschäden sind wir kurzfristig für Sie im Einsatz und begrenzen den Schaden schnellstmöglich.",
      },
      {
        q: "Reinigen Sie auch außerhalb der Geschäftszeiten?",
        a: "Ja, Sonderreinigungen führen wir flexibel auch abends, nachts oder am Wochenende durch, damit Ihr Betrieb möglichst wenig gestört wird.",
      },
      {
        q: "In welchen Orten bieten Sie Sonderreinigungen an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Friedberg.",
      },
      {
        q: "Welche Objekte reinigen Sie im Rahmen von Sonderreinigungen?",
        a: "Unter anderem Großküchen, Werkstätten, Produktions- und Lagerhallen, Veranstaltungsflächen, Tiefgaragen sowie Bereiche nach Wasser-, Sturm- oder Brandschäden.",
      },
      {
        q: "Übernehmen Sie auch Küchentiefenreinigungen in der Gastronomie?",
        a: "Ja, wir reinigen Großküchen inklusive Fettabscheider, Dunstabzug und Geräten – gründlich und nach Hygienestandards.",
      },
    ],
    related: ["grundreinigung-augsburg", "industriereinigung-augsburg", "baureinigung-augsburg"],
  },

  "industriereinigung-augsburg": {
    metaTitle:
      "Industriereinigung Augsburg | Hallen, Maschinen & Böden | MAG Facility Services",
    metaDescription:
      "Industrie- & Hallenreinigung in Augsburg: Produktions- und Lagerhallen, Industrieböden, Maschinen & Anlagen – auch außerhalb der Betriebszeiten. Nach Ihren Sicherheitsvorgaben. Jetzt anfragen!",
    sections: [
      {
        heading: "Industrie- & Hallenreinigung in Augsburg",
        paragraphs: [
          "Industrieumgebungen stellen besondere Anforderungen an die Reinigung: große Flächen, spezielle Böden, Maschinen und teils sensible Produktionsbereiche. Als Gebäudereinigung aus Augsburg reinigen wir Produktions- und Lagerhallen, Industrieböden sowie Maschinen und Anlagen mit geeigneter Technik und geschultem Personal – zuverlässig und effizient.",
          "Wir arbeiten gerne außerhalb Ihrer Betriebszeiten, im Schicht- oder Wochenendbetrieb, damit Ihr Produktionsablauf ungestört bleibt. Dabei beachten wir selbstverständlich Ihre Sicherheits-, Hygiene- und Arbeitsschutzvorgaben.",
        ],
      },
      {
        heading: "Was umfasst die Industriereinigung?",
        paragraphs: [
          "Zur Industriereinigung gehört die Reinigung großer Hallen- und Bodenflächen mit Aufsitz- und Scheuersaugmaschinen, die Reinigung beschichteter Industrieböden sowie die Pflege von Maschinenumfeldern und Anlagen. Ebenso reinigen wir Sozialräume, Sanitäranlagen, Büros und Verkehrswege innerhalb des Betriebs.",
          "Auf Wunsch übernehmen wir außerdem die Reinigung von Regalsystemen, Hochregallagern, Lichtbändern und schwer zugänglichen Bereichen. Wir stimmen den Leistungsumfang genau auf Ihre betrieblichen Anforderungen ab.",
        ],
      },
      {
        heading: "Sicherheit und Zuverlässigkeit im Industrieumfeld",
        paragraphs: [
          "In Industriebetrieben haben Sicherheit und Sauberkeit direkten Einfluss auf Produktivität und Arbeitsschutz. Saubere Böden und Verkehrswege reduzieren die Unfallgefahr, während gepflegte Maschinen und Anlagen länger halten und störungsfreier laufen. Unser Team ist entsprechend geschult und arbeitet nach Ihren Vorgaben.",
          "Mit festen Ansprechpartnern und verlässlichen Abläufen sorgen wir für eine gleichbleibend hohe Reinigungsqualität – abgestimmt auf die besonderen Bedingungen Ihres Betriebs.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Industriereinigung in Augsburg?",
        a: "Die Kosten hängen von Fläche, Bodenart, Verschmutzung und Frequenz ab. Nach einer Besichtigung Ihres Betriebs erstellen wir Ihnen ein individuelles, transparentes Angebot.",
      },
      {
        q: "Reinigen Sie auch außerhalb der Betriebszeiten?",
        a: "Ja, wir arbeiten gerne im Schicht-, Nacht- oder Wochenendbetrieb, damit Ihre Produktion nicht gestört wird.",
      },
      {
        q: "Beachten Sie unsere Sicherheitsvorgaben?",
        a: "Selbstverständlich. Unser Personal wird eingewiesen und arbeitet nach Ihren Sicherheits-, Hygiene- und Arbeitsschutzvorgaben.",
      },
      {
        q: "In welchen Orten bieten Sie Industriereinigung an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Gersthofen, Königsbrunn, Neusäß, Bobingen und Friedberg.",
      },
      {
        q: "Reinigen Sie auch Hochregallager und schwer zugängliche Bereiche?",
        a: "Ja, auf Wunsch reinigen wir Regalsysteme, Hochregallager, Lichtbänder und schwer erreichbare Bereiche mit geeigneter Technik.",
      },
      {
        q: "Mit welcher Technik reinigen Sie große Hallenflächen?",
        a: "Für große Flächen setzen wir Aufsitz- und Scheuersaugmaschinen ein, die auch beschichtete Industrieböden effizient und materialschonend reinigen.",
      },
    ],
    related: ["sonderreinigungen-augsburg", "grundreinigung-augsburg", "baureinigung-augsburg"],
  },

  "fassadenreinigung-augsburg": {
    metaTitle:
      "Fassadenreinigung Augsburg | Putz, Klinker & Algen entfernen | MAG Facility Services",
    metaDescription:
      "Schonende Fassadenreinigung in Augsburg: Putz, Klinker, Metall & Glas. Entfernung von Algen, Moos & Grünbelag – materialgerecht, inkl. Imprägnierung. Jetzt kostenloses Angebot anfordern!",
    sections: [
      {
        heading: "Fassadenreinigung in Augsburg – Ihr Gebäude erstrahlt wie neu",
        paragraphs: [
          "Witterung, Abgase, Algen und Grünbewuchs setzen jeder Fassade mit der Zeit zu und lassen Gebäude ungepflegt wirken. Als Gebäudereinigung aus Augsburg befreien wir Ihre Fassade schonend von Schmutz, Algen, Moosen und Grünbelägen – materialgerecht und gründlich. So lassen wir Ihr Gebäude wieder wie neu erstrahlen und werten es optisch deutlich auf.",
          "Wir reinigen Fassaden aus unterschiedlichsten Materialien: Putz, Klinker, Beton, Metall, Naturstein und Glas. Für jeden Untergrund wählen wir das passende, schonende Verfahren, um das Material nicht zu beschädigen und ein optimales Ergebnis zu erzielen.",
        ],
      },
      {
        heading: "Materialgerechte Verfahren und Höhenarbeiten",
        paragraphs: [
          "Je nach Fassadenart und Verschmutzung setzen wir verschiedene Verfahren ein – von der schonenden Niederdruckreinigung über die Heißwasser-Hochdruckreinigung bis hin zu speziellen Reinigungsmitteln gegen Algen und Moose. Wir prüfen vorab den Zustand des Untergrunds und wählen die Methode, die gründlich reinigt und gleichzeitig die Substanz schont.",
          "Für höher gelegene Bereiche führen wir gesicherte Höhenarbeiten fachgerecht und unter Einhaltung aller Sicherheitsvorgaben durch. So erreichen wir auch schwer zugängliche Fassadenteile zuverlässig.",
        ],
      },
      {
        heading: "Imprägnierung für langanhaltenden Schutz",
        paragraphs: [
          "Auf Wunsch versehen wir Ihre gereinigte Fassade mit einer schützenden Imprägnierung. Diese perlt Wasser ab, erschwert die Wiederansiedlung von Algen und Moosen und hält die Fassade länger sauber. Das reduziert den Reinigungsaufwand in der Zukunft und schützt die Bausubstanz vor Feuchtigkeit.",
          "Eine regelmäßige Fassadenreinigung schützt nicht nur die Optik, sondern auch den Wert Ihrer Immobilie, da Feuchtigkeit und Bewuchs die Bausubstanz langfristig angreifen können.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Fassadenreinigung in Augsburg?",
        a: "Die Kosten hängen von Fläche, Material, Verschmutzungsgrad und Erreichbarkeit ab. Nach einer Besichtigung erstellen wir Ihnen ein transparentes Angebot – auf Wunsch inklusive Imprägnierung.",
      },
      {
        q: "Wie oft sollte eine Fassade gereinigt werden?",
        a: "Das hängt von Standort und Bewuchs ab. In der Regel empfiehlt sich eine Reinigung alle paar Jahre; eine Imprägnierung verlängert die Abstände deutlich.",
      },
      {
        q: "Beschädigt die Reinigung meine Fassade?",
        a: "Nein. Wir wählen für jeden Untergrund ein schonendes, materialgerechtes Verfahren, um Beschädigungen zu vermeiden.",
      },
      {
        q: "In welchen Orten bieten Sie Fassadenreinigung an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Friedberg.",
      },
      {
        q: "Welche Fassadenarten reinigen Sie?",
        a: "Wir reinigen Fassaden aus Putz, Klinker, Beton, Metall, Naturstein und Glas – für jeden Untergrund mit dem passenden, schonenden Verfahren.",
      },
      {
        q: "Was bringt eine Imprägnierung der Fassade?",
        a: "Eine Imprägnierung lässt Wasser abperlen, erschwert die Wiederansiedlung von Algen und Moosen und hält die Fassade länger sauber – das reduziert künftigen Reinigungsaufwand.",
      },
    ],
    related: ["glasreinigung-augsburg", "photovoltaikreinigung-augsburg", "grundreinigung-augsburg"],
  },

  "photovoltaikreinigung-augsburg": {
    metaTitle:
      "Photovoltaik-Reinigung Augsburg | Mehr Ertrag durch saubere Module | MAG Facility Services",
    metaDescription:
      "Professionelle Photovoltaik-Reinigung in Augsburg: schonende Modulreinigung mit entkalktem Reinwasser für mehr Stromertrag & längere Lebensdauer. Jetzt kostenloses Angebot anfordern!",
    sections: [
      {
        heading: "Photovoltaik-Reinigung in Augsburg – für maximalen Ertrag",
        paragraphs: [
          "Verschmutzte Solarmodule verlieren spürbar an Leistung: Staub, Pollen, Laub, Vogelkot und Umweltablagerungen legen sich wie ein Schleier über die Module und verringern den Wirkungsgrad Ihrer Anlage. Als Gebäudereinigung aus Augsburg reinigen wir Ihre Photovoltaikanlage schonend und gründlich – für einen dauerhaft höheren Stromertrag.",
          "Bereits eine dünne Schmutzschicht kann den Ertrag Ihrer PV-Anlage merklich mindern. Eine regelmäßige, professionelle Reinigung sorgt dafür, dass Ihre Module wieder die volle Sonnenenergie aufnehmen – und sich Ihre Investition schneller amortisiert.",
        ],
      },
      {
        heading: "Schonende Reinigung mit entkalktem Reinwasser",
        paragraphs: [
          "Wir reinigen Ihre Solarmodule mit entkalktem, entmineralisiertem Reinwasser und weichen Bürsten. Dieses Verfahren ist besonders schonend und hinterlässt keine Rückstände oder Kalkflecken – die Module trocknen streifenfrei ab. Auf aggressive Chemie verzichten wir vollständig, um die empfindlichen Oberflächen und Beschichtungen nicht zu beschädigen.",
          "Mit Teleskoptechnik erreichen wir auch Anlagen auf Dächern sicher vom Boden aus. Wo nötig, führen wir die Reinigung mit entsprechender Sicherung fachgerecht durch – schonend für Module und Dachkonstruktion.",
        ],
      },
      {
        heading: "Längere Lebensdauer Ihrer Anlage",
        paragraphs: [
          "Eine saubere PV-Anlage arbeitet nicht nur effizienter, sondern hält auch länger: Ablagerungen wie Vogelkot oder Flechten können sich bei dauerhafter Verschmutzung in die Oberfläche einbrennen und die Module dauerhaft schädigen. Durch regelmäßige Reinigung beugen Sie dem vor und sichern langfristig den Ertrag Ihrer Anlage.",
          "Wir beraten Sie gerne zum optimalen Reinigungsintervall – abhängig von Standort, Umgebung und Neigung Ihrer Anlage.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Photovoltaik-Reinigung in Augsburg?",
        a: "Die Kosten richten sich nach Anzahl und Erreichbarkeit der Module sowie dem Verschmutzungsgrad. Nach einer kurzen Aufnahme erhalten Sie ein transparentes Angebot.",
      },
      {
        q: "Wie oft sollte eine PV-Anlage gereinigt werden?",
        a: "Je nach Standort und Umgebung empfiehlt sich eine Reinigung alle ein bis zwei Jahre. In der Nähe von Feldern, Wäldern oder Ställen kann ein kürzeres Intervall sinnvoll sein.",
      },
      {
        q: "Beschädigt die Reinigung meine Module?",
        a: "Nein. Wir reinigen ausschließlich mit weichen Bürsten und entkalktem Reinwasser – ganz ohne aggressive Chemie und materialschonend.",
      },
      {
        q: "In welchen Orten bieten Sie PV-Reinigung an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Bobingen und Schwabmünchen.",
      },
      {
        q: "Kann ich meine PV-Anlage nicht einfach selbst reinigen?",
        a: "Von einer Reinigung in Eigenregie raten wir ab: Falsche Mittel oder hoher Druck können die Module beschädigen, und die Arbeit auf dem Dach birgt Unfallgefahr. Wir arbeiten sicher und materialschonend.",
      },
      {
        q: "Reinigen Sie auch größere Freiflächen- und Dachanlagen?",
        a: "Ja, wir reinigen sowohl Dach- als auch Freiflächenanlagen unterschiedlicher Größe – mit Teleskoptechnik und bei Bedarf gesicherten Höhenarbeiten.",
      },
    ],
    related: ["fassadenreinigung-augsburg", "glasreinigung-augsburg", "hausmeisterservice-augsburg"],
  },

  "hausmeisterservice-augsburg": {
    metaTitle:
      "Hausmeisterservice Augsburg | Objektbetreuung & Grünpflege | MAG Facility Services",
    metaDescription:
      "Zuverlässiger Hausmeisterservice in Augsburg: Objektbetreuung, Kleinreparaturen, Außenanlagen & Grünpflege für Wohn- und Gewerbeimmobilien. Werterhaltend & verlässlich. Jetzt anfragen!",
    sections: [
      {
        heading: "Hausmeisterservice in Augsburg – Ihre Immobilie in besten Händen",
        paragraphs: [
          "Ein gepflegtes Objekt braucht kontinuierliche Betreuung. Als Gebäudereinigung aus Augsburg bieten wir einen zuverlässigen Hausmeisterservice, der Eigentümer, Verwaltungen und Gewerbetreibende rundum entlastet. Von der regelmäßigen Objektkontrolle über kleine Reparaturen bis zur Pflege der Außenanlagen halten wir Ihre Immobilie dauerhaft in Schuss.",
          "Mit einem festen Ansprechpartner vor Ort sorgen wir für kurze Wege und schnelle Reaktionszeiten. So werden Mängel frühzeitig erkannt und behoben, bevor größere Schäden entstehen – das schützt den Wert Ihrer Immobilie und sorgt für zufriedene Mieter.",
        ],
      },
      {
        heading: "Unsere Leistungen im Hausmeisterservice",
        paragraphs: [
          "Zu unserem Hausmeisterservice gehören regelmäßige Kontrollgänge, kleine Reparaturen und Instandhaltungsarbeiten, die Überwachung der Haustechnik sowie die Betreuung von Außenanlagen. Wir übernehmen die Pflege von Grünflächen, das Rasenmähen, den Heckenschnitt und die Reinigung von Wegen, Höfen und Parkplätzen.",
          "Darüber hinaus koordinieren wir bei Bedarf Handwerker und Fachfirmen, führen Zählerstände, überwachen die Einhaltung von Verkehrssicherungspflichten und stehen als Ansprechpartner für Mieter zur Verfügung. Den Leistungsumfang stimmen wir individuell auf Ihre Immobilie ab.",
        ],
      },
      {
        heading: "Werterhaltung durch kontinuierliche Betreuung",
        paragraphs: [
          "Eine kontinuierliche Objektbetreuung ist die beste Investition in den Werterhalt Ihrer Immobilie. Regelmäßige Kontrollen und zeitnahe kleine Reparaturen verhindern, dass sich kleine Mängel zu teuren Schäden entwickeln. Gleichzeitig erhöht ein gepflegtes Erscheinungsbild die Zufriedenheit der Mieter und die Attraktivität des Objekts.",
          "Gerne kombinieren wir den Hausmeisterservice mit unserer Treppenhausreinigung, dem Winterdienst und der Müllentsorgung, sodass Sie die komplette Objektbetreuung aus einer Hand erhalten.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet ein Hausmeisterservice in Augsburg?",
        a: "Die Kosten richten sich nach Objektgröße und gewünschtem Leistungsumfang. Wir erstellen Ihnen ein individuelles Angebot – auf Stunden- oder Pauschalbasis.",
      },
      {
        q: "Übernehmen Sie auch die Grünpflege?",
        a: "Ja, wir pflegen Grünflächen, mähen Rasen, schneiden Hecken und halten Wege, Höfe und Parkplätze sauber.",
      },
      {
        q: "Sind Sie auch für mehrere Objekte verfügbar?",
        a: "Ja, für Hausverwaltungen betreuen wir gerne mehrere Objekte mit einheitlicher Qualität und zentraler Ansprechperson.",
      },
      {
        q: "In welchen Orten bieten Sie Hausmeisterservice an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Friedberg.",
      },
      {
        q: "Welche Aufgaben übernimmt der Hausmeisterservice genau?",
        a: "Regelmäßige Kontrollgänge, kleine Reparaturen, Überwachung der Haustechnik, Grün- und Außenanlagenpflege sowie die Koordination von Handwerkern – individuell nach Ihrem Bedarf.",
      },
      {
        q: "Koordinieren Sie bei Bedarf auch Handwerker und Fachfirmen?",
        a: "Ja, auf Wunsch koordinieren wir Handwerker und Fachfirmen und behalten den Zustand Ihrer Immobilie im Blick, damit alles reibungslos läuft.",
      },
    ],
    related: ["treppenhausreinigung-augsburg", "winterdienst-augsburg", "muellentsorgung-augsburg"],
  },

  "winterdienst-augsburg": {
    metaTitle:
      "Winterdienst Augsburg | Schneeräumung & Streudienst | MAG Facility Services",
    metaDescription:
      "Zuverlässiger Winterdienst in Augsburg: Schneeräumung & Streudienst für sichere Wege, Zufahrten & Parkplätze – inkl. rechtssicherer Dokumentation. Räum- und Streupflicht abgeben. Jetzt anfragen!",
    sections: [
      {
        heading: "Winterdienst in Augsburg – sichere Wege im Winter",
        paragraphs: [
          "Als Eigentümer oder Verwalter tragen Sie die gesetzliche Räum- und Streupflicht. Kommen Sie dieser nicht nach, drohen Haftungsrisiken bei Unfällen. Als Gebäudereinigung aus Augsburg übernehmen wir Ihren Winterdienst zuverlässig: Wir sorgen für schnee- und eisfreie Gehwege, Zufahrten und Parkplätze – rechtssicher und pünktlich.",
          "Unser Team ist während der Wintermonate früh morgens und bei Bedarf mehrmals täglich im Einsatz, um die Sicherheit für Mieter, Kunden und Besucher zu gewährleisten. So geben Sie Ihre Räum- und Streupflicht sorgenfrei in professionelle Hände.",
        ],
      },
      {
        heading: "Schneeräumung, Streudienst & Dokumentation",
        paragraphs: [
          "Zu unserem Winterdienst gehören die Schneeräumung von Gehwegen, Zufahrten, Höfen und Parkplätzen sowie das Streuen bei Glätte mit geeigneten, umweltverträglichen Streumitteln. Wir beobachten die Wetterlage aufmerksam und rücken rechtzeitig aus, damit gefährliche Glätte gar nicht erst entsteht.",
          "Jeden Einsatz dokumentieren wir rechtssicher mit Datum, Uhrzeit und durchgeführten Maßnahmen. Diese Dokumentation ist im Schadensfall entscheidend und gibt Ihnen als Eigentümer rechtliche Sicherheit.",
        ],
      },
      {
        heading: "Rechtssicherheit und Zuverlässigkeit",
        paragraphs: [
          "Die Übertragung der Räum- und Streupflicht an einen professionellen Dienstleister entlastet Sie rechtlich und praktisch. Sie müssen nicht mehr selbst früh aufstehen oder bei jedem Wetter bereitstehen – wir übernehmen die Verantwortung und den Einsatz zuverlässig.",
          "Für eine lückenlose Betreuung kombinieren viele Kunden den Winterdienst mit unserem Hausmeisterservice, sodass die Objektbetreuung das ganze Jahr über aus einer Hand erfolgt.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet ein Winterdienst in Augsburg?",
        a: "Die Kosten richten sich nach Fläche, Lage und vereinbartem Leistungsumfang. Wir bieten meist Saisonpauschalen an und erstellen Ihnen ein transparentes Angebot.",
      },
      {
        q: "Wann sind Sie im Einsatz?",
        a: "Wir beobachten die Wetterlage und rücken früh morgens sowie bei Bedarf mehrmals täglich aus, damit Ihre Flächen rechtzeitig schnee- und eisfrei sind.",
      },
      {
        q: "Erhalte ich einen Nachweis über die Einsätze?",
        a: "Ja, wir dokumentieren jeden Einsatz rechtssicher mit Datum, Uhrzeit und Maßnahmen – wichtig für Ihre rechtliche Absicherung.",
      },
      {
        q: "In welchen Orten bieten Sie Winterdienst an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Friedberg.",
      },
      {
        q: "Übernehmen Sie die Haftung bei Glätteunfällen?",
        a: "Mit der Übertragung der Räum- und Streupflicht übernehmen wir die Durchführung und dokumentieren jeden Einsatz rechtssicher – das entlastet Sie als Eigentümer erheblich.",
      },
      {
        q: "Welche Streumittel verwenden Sie?",
        a: "Wir setzen geeignete, möglichst umweltverträgliche Streumittel ein und richten uns dabei nach den örtlichen Vorgaben und der jeweiligen Fläche.",
      },
    ],
    related: ["hausmeisterservice-augsburg", "muellentsorgung-augsburg", "treppenhausreinigung-augsburg"],
  },

  "teppich-polsterreinigung-augsburg": {
    metaTitle:
      "Teppich- & Polsterreinigung Augsburg | Tiefenreinigung | MAG Facility Services",
    metaDescription:
      "Professionelle Teppich- & Polsterreinigung in Augsburg: Sprüh-Extraktion entfernt Schmutz, Flecken & Gerüche aus Teppichböden, Sofas & Sitzgruppen. Schnelle Trocknung. Jetzt anfragen!",
    sections: [
      {
        heading: "Teppich- & Polsterreinigung in Augsburg – frisch und hygienisch",
        paragraphs: [
          "Teppiche und Polstermöbel binden mit der Zeit Staub, Milben, Flecken und Gerüche tief im Gewebe. Als Gebäudereinigung aus Augsburg frischen wir Ihre Teppichböden, Sofas, Sessel und Sitzgruppen mit einer professionellen Tiefenreinigung wieder auf – für ein sauberes, hygienisches und angenehm frisches Ergebnis.",
          "Ob im Büro, in der Praxis, im Hotel oder im Privathaushalt: Wir reinigen Textilien schonend und gründlich und verlängern so ihre Lebensdauer. Gerade in stark frequentierten Bereichen lohnt sich eine regelmäßige Reinigung, um ein gepflegtes Erscheinungsbild zu bewahren.",
        ],
      },
      {
        heading: "Sprüh-Extraktion für tiefenwirksame Sauberkeit",
        paragraphs: [
          "Wir arbeiten mit dem bewährten Sprüh-Extraktionsverfahren: Dabei wird eine Reinigungslösung tief ins Gewebe eingebracht, die den Schmutz löst, und anschließend gemeinsam mit dem gelösten Schmutz wieder abgesaugt. So werden auch tiefsitzende Verschmutzungen, Milben und Gerüche zuverlässig entfernt – deutlich gründlicher als bei einer oberflächlichen Reinigung.",
          "Hartnäckige Flecken behandeln wir gezielt vor. Dank des schonenden Verfahrens und der kurzen Trocknungszeit sind Ihre Räume und Möbel schnell wieder nutzbar.",
        ],
      },
      {
        heading: "Materialschonend und mit kurzer Trocknungszeit",
        paragraphs: [
          "Wir stimmen das Reinigungsverfahren und die eingesetzten Mittel auf das jeweilige Material ab, um empfindliche Textilien nicht zu beschädigen. Die eingesetzte Technik entzieht dem Gewebe möglichst viel Feuchtigkeit, sodass Teppiche und Polster schnell trocknen und Sie Ihre Räume rasch wieder nutzen können.",
          "Für ein rundum gepflegtes Objekt kombinieren wir die Teppich- und Polsterreinigung gerne mit unserer Grund- oder Unterhaltsreinigung.",
        ],
      },
    ],
    faqs: [
      {
        q: "Was kostet eine Teppich- oder Polsterreinigung in Augsburg?",
        a: "Der Preis richtet sich nach Fläche bzw. Anzahl der Möbelstücke und dem Verschmutzungsgrad. Nach einer kurzen Aufnahme erhalten Sie ein transparentes Angebot.",
      },
      {
        q: "Wie lange dauert die Trocknung?",
        a: "Dank der Sprüh-Extraktion mit starker Absaugung sind Teppiche und Polster meist innerhalb weniger Stunden wieder trocken und nutzbar.",
      },
      {
        q: "Entfernen Sie auch hartnäckige Flecken und Gerüche?",
        a: "Ja, wir behandeln Flecken gezielt vor und entfernen mit dem Extraktionsverfahren auch tiefsitzende Verschmutzungen und Gerüche.",
      },
      {
        q: "In welchen Orten bieten Sie Teppich- & Polsterreinigung an?",
        a: "Wir sind in Augsburg und Umgebung tätig, u. a. in Königsbrunn, Gersthofen, Neusäß, Stadtbergen und Friedberg.",
      },
      {
        q: "Welche Teppiche und Polster können Sie reinigen?",
        a: "Wir reinigen Teppichböden, Läufer, Sofas, Sessel, Bürostühle und Sitzgruppen aus den meisten Materialien – schonend und auf das Gewebe abgestimmt.",
      },
      {
        q: "Entfernen Sie auch Tierhaare, Milben und Allergene?",
        a: "Ja, das Sprüh-Extraktionsverfahren entfernt neben Schmutz und Gerüchen auch Tierhaare, Milben und Allergene tief aus dem Gewebe.",
      },
    ],
    related: ["grundreinigung-augsburg", "unterhaltsreinigung-augsburg", "sonderreinigungen-augsburg"],
  },
};


// Bilder pro Leistung (moderate Größe). Mehrere Bilder = Slideshow.
const U = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=800`;

export const serviceImages = {
  "unterhaltsreinigung-augsburg": [
    U("1669101602124-f5b78895d91c"),
    U("1669101602108-fa5ba89507ee"),
    U("1627905646269-7f034dcc5738"),
  ],
  "treppenhausreinigung-augsburg": [
    U("1776671069401-1f4647ce5e5e"),
    U("1774500339025-378564c4b7c5"),
    U("1563917792532-1176a7708aae"),
  ],
  "glasreinigung-augsburg": [
    U("1721620958961-cccc239cbb49"),
    U("1512479373983-bd28a541041b"),
    U("1632927063333-df848f5f916a"),
  ],
  "grundreinigung-augsburg": [
    U("1718152421680-d1580e843cc9"),
    U("1718152422704-bd21030a1a99"),
    U("1718152423993-a29048dbc223"),
  ],
  "baureinigung-augsburg": [
    U("1612725118809-0bebfb71a551"),
    U("1685464196387-854858ce0f4f"),
    U("1630683924997-fe27050a0416"),
  ],
  "muellentsorgung-augsburg": [
    U("1532996122724-e3c354a0b15b"),
    U("1611284446314-60a58ac0deb9"),
    U("1605600659908-0ef719419d41"),
  ],
  "sonderreinigungen-augsburg": [
    U("1580842402762-6f5868c17412"),
    U("1615506355925-dd0a54d099dd"),
    U("1611416553159-262dd1e1c5c6"),
  ],
  "industriereinigung-augsburg": [
    U("1771531072574-af6ed6b954c0"),
    U("1771530789155-b1f03fbf82b5"),
    U("1772305336606-989a457ffbae"),
  ],
  "fassadenreinigung-augsburg": [
    U("1775235288784-57296a26b75c"),
    U("1632927063333-df848f5f916a"),
    U("1512479373983-bd28a541041b"),
  ],
  "photovoltaikreinigung-augsburg": [
    U("1754619880959-2b0528375883"),
    "https://images.pexels.com/photos/14614266/pexels-photo-14614266.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=800",
    U("1663321508309-4ceb96a3c791"),
  ],
  "hausmeisterservice-augsburg": [
    U("1505798577917-a65157d3320a"),
    U("1676311396794-f14881e9daaa"),
    U("1562259929-b4e1fd3aef09"),
  ],
  "winterdienst-augsburg": [
    U("1770101516555-c7af257060ac"),
    U("1769955506606-7d6437f9c9d1"),
    U("1771149271747-5e506e3f7b6e"),
  ],
  "teppich-polsterreinigung-augsburg": [
    U("1527515637462-cff94eecc1ac"),
    U("1527515673510-8aa78ce21f9b"),
  ],
};
